const collectionName = 'categories';

export { collectionName };
